<template>
  <div class="min-h-screen flex items-center justify-center bg-white">
    <div class="max-w-2xl px-6 text-center">
      <div class="relative">
        <h1 class="text-[150px] font-bold text-primary-900/10">
          {{ error?.statusCode || "500" }}
        </h1>
        <div class="absolute inset-0 flex items-center justify-center">
          <img
            src="~/assets/img/404.jpg"
            alt="Error"
            class="w-72 object-contain"
          />
        </div>
      </div>

      <div class="mt-8 space-y-4">
        <h2 class="text-3xl font-bold text-primary-900">
          {{ getErrorTitle }}
        </h2>
        <p class="text-lg text-slate-600">
          {{ getErrorMessage }}
          <br />
          {{ error?.message || "Please try again later." }}
        </p>

        <Button
          label="Return Home"
          icon="pi pi-home"
          raised
          @click="handleError"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";

const props = defineProps({
  error: Object as () => NuxtError,
});

const getErrorTitle = computed(() => {
  switch (props.error?.statusCode) {
    case 404:
      return "Oops! Page not found";
    case 500:
      return "Oops! Server Error";
    default:
      return "Oops! Something went wrong";
  }
});

const getErrorMessage = computed(() => {
  switch (props.error?.statusCode) {
    case 404:
      return "We can't seem to find the page you're looking for.";
    case 500:
      return "Our server encountered an error while processing your request.";
    default:
      return "An unexpected error occurred while processing your request.";
  }
});

const handleError = () => clearError({ redirect: "/" });
</script>
